const getters = {
  token: (state) => state.user.token,
  roles: (state) => state.user.roles,
  permission_routes: state => state.permission.routes,
  chat: (state) => state.user.chat
}
export default getters
